import React, { useEffect, useState, useMemo } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'HOC/withRouter'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { createStructuredSelector } from "reselect"
import styled from "styled-components"

import Button from 'Components/Button'

//SELECTORS
import {
  selectPrimaryActionColor,
} from "Containers/BusinessInformations/selectors"

import {
  selectLastWidgetSaved,
} from "Containers/Page/selectors.js"

import Widget from "Containers/Widget"

import {
  ConfigurationContainer,
  EmptyWidgetContainer
} from "Containers/Widget/Widget.styles.js"

const MultiTabHeader = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0px;
`

const TabsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${({ alignment }) => alignment ? alignment : "flex-start"};
`

var Tab = styled.div`
  display: flex;
  flex-direction: row;
  cursor: pointer;
  border-bottom: ${({ isSelected, effectColor }) => isSelected && effectColor ? `2px solid ${effectColor}` : "2px solid transparent"};
  margin: 0px 10px;
  padding: 5px;
`

var TabIcon = styled.i`
  margin: 0px 5px;
`

var TabName = styled.div`
`


const cogMargin = "0px 20px 0px 0px"
const cogPadding = "10px"

function WidgetMultiTab({
  // tabs,
  widgetList,
  id,
  onWidgetTabClick,
  widgetInfo,
  actualWidgetInfoDisplayed,
  layout,
  currentColsNumber,
  sideMenuColor,
  breakpoint,
  isEdition,
  isAWidgetFromSettings,
  onWidgetConfigClick,
  onWidgetFullScreenClick,
  showWidgetConfigButton,
  multiTabSelectedInConfig,
  partialTrad,
  //redux
  primaryActionColor,
  lastWidgetSaved,
}) {

  const {
    CONFIGURE,
    WIDGET_NOT_CONFIGURED
  } = partialTrad

  const getInitialTabSelected = (widgetInfo) => {
    var tabList = widgetInfo?.tabsInfos?.tabsList
    if (tabList && Array.isArray(tabList) && tabList.length > 0) {
      return tabList[0]
    }
    return undefined
  }

  const getInitialWidgetDisplay = () => {
    if (isAWidgetFromSettings) return actualWidgetInfoDisplayed
    else {
      var tabList = widgetInfo?.tabsInfos?.tabsList
      var firstTab = undefined
      if (tabList && Array.isArray(tabList) && tabList.length > 0) {
        firstTab = tabList[0]
      }
      var widgetFound = undefined
      if (widgetList !== undefined && firstTab !== undefined) {
        var tabWidgetRef = firstTab.widgetReference
        widgetFound = widgetList.find(widget => {
          return widget?.multiTabReference === tabWidgetRef
        })
      }
      if (widgetFound) return widgetFound
    }
    return undefined
  }

  const [selectedTab, setSelectedTab] = useState(getInitialTabSelected(widgetInfo))
  const [widgetInfoDisplay, setWidgetInfoDisplay] = useState(getInitialWidgetDisplay())
  const [lastWidgetSavedTimestamp, setLastWidgetSavedTimestamp] = useState(0)

  useEffect(() => {
    //from config
    if (isAWidgetFromSettings) {
      setWidgetInfoDisplay(actualWidgetInfoDisplayed)
    }
  }, [actualWidgetInfoDisplayed])

  useEffect(() => {
    const { widgetId: lastWidgetSavedId, timestamp } = lastWidgetSaved
    if (lastWidgetSavedId === widgetInfo?._id?.$oid && lastWidgetSavedTimestamp !== timestamp) {
      setLastWidgetSavedTimestamp(timestamp)
      var newTab = getInitialTabSelected(widgetInfo)
      setSelectedTab(newTab)
      var tabWidgetRef = newTab?.widgetReference
      var widgetFound = undefined
      if (widgetList !== undefined) {
        widgetFound = widgetList.find(widget => widget?.multiTabReference === tabWidgetRef)
      }

      if (widgetFound) setWidgetInfoDisplay(widgetFound)
    }
  }, [lastWidgetSaved])

  useEffect(() => {
    if (multiTabSelectedInConfig === undefined || multiTabSelectedInConfig?.widgetReference === undefined) return;
    setSelectedTab(multiTabSelectedInConfig)
  }, [multiTabSelectedInConfig])

  const onTabClick = (tab) => {
    var tabWidgetRef = tab?.widgetReference
    if (tabWidgetRef === undefined || selectedTab?.widgetReference === tabWidgetRef) return;

    if (isAWidgetFromSettings) {
      //shared with parent component
      onWidgetTabClick(tab)
    } else {
      //local
      setSelectedTab(tab)
    }
    var widgetFound = undefined
    if (widgetList !== undefined) {
      widgetFound = widgetList.find(widget => {
        return widget?.multiTabReference === tabWidgetRef
      })
    }
    if (widgetFound) setWidgetInfoDisplay(widgetFound)
  }

  const getAlignementFromWidgetInfo = (widgetInfo) => {
    var alignmentInWidget = widgetInfo?.tabsInfos?.alignment
    var alignment = alignmentInWidget !== undefined ? alignmentInWidget : "left"
    switch (alignment) {
      case 'left':
        return "flex-start"
      case 'center':
        return "center"
      case 'right':
        return "flex-end"
      default:
        return "flex-start"
    }
  }

  const multiTabIsEmpty = Array.isArray(widgetInfo?.tabsInfos?.tabsList) && widgetInfo.tabsInfos.tabsList.length === 0
  const showCenteredConfigButton = isEdition && multiTabIsEmpty && showWidgetConfigButton
  const showLittleConfigIcon = isEdition && !multiTabIsEmpty && showWidgetConfigButton
  const showWidgetNotConfiguredText = !isEdition && multiTabIsEmpty

  return (
    <div id="widgetMultiTab" style={{ width: "100%", height: "100%" }}>
      <MultiTabHeader id="multiTabHeader">
        <TabsContainer id="tabsContainer" alignment={getAlignementFromWidgetInfo(widgetInfo)}>
          {Array.isArray(widgetInfo?.tabsInfos?.tabsList) && widgetInfo.tabsInfos.tabsList.map(tab => {
            var tabWidgetRef = tab.widgetReference
            var effectColor = tab.effectColor
            return (
              <Tab
                key={tabWidgetRef}
                id={tabWidgetRef}
                isSelected={tabWidgetRef === selectedTab?.widgetReference}
                effectColor={effectColor}
                color={primaryActionColor}
                onClick={() => onTabClick(tab)}
              >
                <TabIcon className={tab.icon} />
                <TabName>
                  {tab.name}
                </TabName>
              </Tab>
            )
          })}
        </TabsContainer>
        {showLittleConfigIcon &&
          <Button
            color={primaryActionColor}
            onClick={() => onWidgetConfigClick(widgetInfo?._id?.$oid)}
            backgroundColor="white"
            borderColor={primaryActionColor}
            icon={<i className="fas fa-cog" />}
            style={{ margin: cogMargin, padding: cogPadding, height: "30px", width: "30px" }}
          />
        }
      </MultiTabHeader>
      {showCenteredConfigButton &&
        <ConfigurationContainer>
          <div onMouseDown={(e) => e.stopPropagation()}>
            <Button
              color="white"
              backgroundColor={primaryActionColor}
              borderColor={primaryActionColor}
              colorHover={primaryActionColor}
              backgroundColorHover="white"
              icon={<i className="fas fa-cog" />}
              text={CONFIGURE}
              onClick={() => onWidgetConfigClick(widgetInfo?._id?.$oid)}
            />
          </div>
        </ConfigurationContainer>
      }
      {showWidgetNotConfiguredText &&
        <EmptyWidgetContainer key={widgetInfo?._id?.$oid}>
          {WIDGET_NOT_CONFIGURED}
        </EmptyWidgetContainer>
      }
      {!multiTabIsEmpty && widgetInfoDisplay !== undefined && <div
        id="multiTabWidgetContainer"
        style={{ width: "100%", height: "calc(100% - 40px)" }}
      >
        <Widget
          id={widgetInfoDisplay._id.$oid}
          widgetInfo={widgetInfoDisplay}
          currentColsNumber={currentColsNumber}
          sideMenuColor={sideMenuColor}
          layout={layout}
          breakpoint={breakpoint}
          widgetList={widgetList}
          isEdition={isEdition}
          isAWidgetFromSettings={false}
          onWidgetConfigClick={onWidgetConfigClick}
          onWidgetFullScreenClick={onWidgetFullScreenClick}
          showWidgetConfigButton={false}
        />
      </div>}
    </div>
  )
}

WidgetMultiTab.propTypes = {
  primaryActionColor: PropTypes.string,
  partialTrad: PropTypes.object,
}

WidgetMultiTab.defaultProps = {
  partialTrad: {},
}

const mapDispatchToProps = dispatch => ({
})

const mapStateToProps = () => createStructuredSelector({
  primaryActionColor: selectPrimaryActionColor,
  lastWidgetSaved: selectLastWidgetSaved,
})

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
)

export default compose(
  withRouter,
  withConnect,
)(WidgetMultiTab)
